<template>
    <a href="https://www.linkedin.com/in/gregory-sachnine-b7124a100/" target="_blank">
        Se rencontrer <img class="picto" src="~/assets/svg/linkedin.svg" aria-hidden="true" alt="">
    </a>
</template>

<style scoped lang="postcss">
a {
    @apply flex justify-center items-center gap-3 bg-primary text-tertiary font-normal py-3 px-8 rounded-4xl transition-colors duration-300
    focus:bg-secondary focus:text-white focus:ring-secondary
    hover:bg-secondary hover:text-white;
}
.picto {
    @apply w-6 h-6;
}
</style>